<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-09-30 15:55:18
 * @LastEditors: xgx
 * @LastEditTime: 2022-09-30 15:55:19
-->
<template>
   <div>州长信箱</div>
</template>

<script>
export default {

}
</script>

<style>

</style>